<app-simple-modal [title]="'Crear Empresa'" (close)="close.emit($event)">
	<div fields>
		<app-company-request [newCompany]="newCompany"></app-company-request>
	</div>
	<div buttons>
		<app-loading-button [object]="buttonSave" [disabled]="getDisabledGeneral() || this.newCompany.activities.length == 0
		|| this.newCompany.contacts.length == 0
		|| this.newCompany.phones.length == 0" (clicked)="saveCompany()"></app-loading-button>
	</div>
</app-simple-modal>